<template>
  <div class="contain">
    <div style="margin-top: 4rem; font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">登入 Login</div>
    <!-- {{ $t('other.login') }} -->
    <div style="display: flex; margin-top: 0.5rem; margin-bottom: 3rem">
      <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin: 0 0.5rem"></span>
      <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin: 0 0.5rem"></span>
      <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin: 0 0.5rem"></span>
    </div>
    <div class="security-box">
      <el-form ref="form" status-icon :model="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item prop="userNo">
          <div class="security-title">
            帳戶名稱（學生帳戶 / 家長電郵）<br />
            Login name （Student’s Username / Parent's Email）
          </div>
          <el-input v-model="form.userNo" placeholder="登錄名 Username"> </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <div class="security-title">密碼<br />Password</div>
          <el-input v-model="form.password" show-password placeholder="密碼 Password"> </el-input>
          <!-- <div slot="error" slot-scope="{ error }" style="line-height:1.6;font-size:14px;color: #D20000;">{{error}}
  <span v-show="error=='錯誤密碼。'" class="cursor-pointer" style="color:#0000FF;text-decoration: underline;" @click="onForgetPassword">忘記密碼？</span>
</div> -->
        </el-form-item>
        <!--                <div id="grecaptcha" style="margin-top: 1.5rem" :key="datekey"></div>-->
      </el-form>
      <div style="display: flex; flex-direction: column; margin-top: 1rem">
        <el-button round @click="onLogin" class="security-button">登入 Login</el-button>
        <div style="text-align: center; color: #0000ff; padding: 1.25rem 1.25rem 0">
          <span style="cursor: pointer; text-decoration: underline; white-space: nowrap" @click="$router.push({ name: 'faq' })">用戶登錄幫助 Help</span><el-divider direction="vertical"></el-divider
        ><span style="cursor: pointer; text-decoration: underline; white-space: nowrap" @click="$router.push({ name: 'disclaimer' })">使用條款 Terms of use</span>
          <el-divider direction="vertical"></el-divider
          ><span class="cursor-pointer" style="color: #0000ff; text-decoration: underline; white-space: nowrap" @click="onForgetPassword">忘記密碼？ Forgotten your password?</span>
          <el-divider style="padding: 0 1rem"></el-divider>
        </div>
        <div style="text-align: center; color: #444444">沒有家長帳戶？ No parent account?</div>
        <el-button round @click="onRegister" class="security-button">註冊 Register</el-button>
        <!-- {{ $t('other.register') }} -->
      </div>
    </div>
    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>

<script>
import loadingDialog from "@/components/loadingDialog/index";
import { login, recaptcha } from "@/api/security";
import { getProfile } from "@/api/user";
import { setUserInfo, setToken, getUserInfo } from "@/utils/auth";
import { isPC } from "@/utils/is-rules";
export default {
  components: { loadingDialog },
  data() {
    return {
      centerDialogVisible: false,
      form: {
        userNo: "",
        password: "",
      },
      rules: {
        userNo: [
          {
            required: true,
            message: "請輸入帳戶名稱 Please enter login name",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "請輸入密碼 Please enter password",
            trigger: "blur",
          },
        ],
      },
      recaptchaResult: false,
      datekey: Date.now(),
      detail: {},
    };
  },
  mounted() {
    // let that = this;
    // // that.initial()
    // let time = 0;
    // let intervalId = setInterval(function () {
    //     time++;
    //     // this.datekey = Date.now()
    //     if (window.grecaptcha || time == 20) {
    //         that.initial();
    //         clearInterval(intervalId);
    //         return;
    //     }
    // }, 500);
    this.$store.dispatch("setIsPC", isPC());
  },
  methods: {
    initial() {
      window.grecaptcha.render("grecaptcha", {
        // sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',//test 6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe
        sitekey: "6LfLkCsrAAAAADPtgyCgmLq5U-36xqd2nzd-tZxH",
        hl: this.$store.getters.language == "en" ? "en" : "zh-HK",
        callback: this.submit,
      });
    },
    submit(token) {
      recaptcha({ token }).then((v) => {
        this.recaptchaResult = v.data.success;
      });
    },
    onForgetPassword() {
      this.$router.push({ path: "/forget-password" });
    },
    onRegister() {
      this.$router.push({ path: "/register" });
    },
    onLogin() {
      // this.login();//直接登录，跳过验证
      //有验证的登录
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
      //有验证的登录
      // this.$refs.form.validate((valid) => {
      //     if (this.recaptchaResult) {
      //         if (valid) {
      //             this.login();
      //         } else {
      //             return false;
      //         }
      //     } else {
      //         this.$message.error('You did not enter the correct captcha response. Please try again');
      //         window.grecaptcha.reset();
      //     }
      // });
    },
    login() {
      let that = this
      login(this.form)
          .then((v) => {
            // this.$i18n.locale = "zh_tc";
            // this.$store.dispatch("setLanguage", "zh_tc");
            setUserInfo("userInfo", v.data);
            setUserInfo("refreshToken", v.data.refreshToken);
            setToken(v.data.accessToken);
            getProfile().then((v) => {
              if (getUserInfo("userInfo").roleName == this.roleNameParent) {
                setUserInfo("userProfile", v.data);
                if (v.data.students.length > 0) {
                  let list = v.data.students.filter((item) => {
                    return item.subscriptions.length > 0;
                  });
                  setTimeout(() => {
                    if (list.length > 0) { that.$router.push({ path: that.$store.getters.login }).catch(() => {});}
                    else {
                      that.$router.push({
                        name: "subscribe",
                        query: {
                          id: getUserInfo("userInfo").id,
                          isRenew: true,
                          needSubscribe: true,
                        },
                      }).catch(() => {});
                    }
                  }, 500);
                } else {
                  setTimeout(() => {
                    that.$router.push({
                      name: "subscribe",
                      query: {
                        id: getUserInfo("userInfo").id,
                        needSubscribe: true,
                      },
                    }).catch(() => {});
                  }, 500);
                }
              } else if (getUserInfo("userInfo").roleName == this.roleNameStudent) {
                this.detail = JSON.parse(JSON.stringify(v.data));
                // let now = new Date().getTime();
                // this.detail.subscriptionIndex = this.detail.subscriptions.findIndex((item) => {
                //     return new Date(item.startDate).getTime() < now && new Date(item.endDate).getTime() > now;
                // });
                this.detail.subscriptionIndex = 0;
                setUserInfo("userProfile", this.detail);
                this.$store.dispatch("setGradeId", this.detail.subscriptions[this.detail.subscriptionIndex].gradeId);
                setTimeout(() => {
                  that.$router.push({ path: "/studentProgramme" }).catch(() => {});
                }, 500);
              }
            });
          })
          .catch((err) => {
            switch (
                err.response.data.error_code //err.response.data.error_message
                ) {
              case "INVALID_USER_ACCOUNT":
                this.$refs.form.fields[0].validateState = "error";
                this.$refs.form.fields[0].validateMessage = "錯誤帳戶名稱。家長可以查看學生帳戶名稱。 Wrong account name. Parents can view student account names.";
                break;
              case "INVALID_PARENT_PASSWORD":
                this.$refs.form.fields[1].validateState = "error";
                this.$refs.form.fields[1].validateMessage = "錯誤密碼。 Wrong password.";
                break;
              case "INVALID_STUDENT_PASSWORD":
                this.$refs.form.fields[1].validateState = "error";
                this.$refs.form.fields[1].validateMessage = "錯誤密碼。 家長可以替學生重設密碼。 Wrong password.  Parents can reset passwords for students.";
                break;
              case "SUBSCRIPTION_EXPIRED_ERROR":
                this.onShowError(0);
                break;
              case "NO_SUBSCRIPTION_ERROR":
                this.onShowError(1);
                break;
              case "SUBSCRIPTION_NOT_START_ERROR":
                this.onShowError(2);
                break;
              case "AUTH_ERROR":
                this.$refs.form.fields[0].validateState = "error";
                this.$refs.form.fields[0].validateMessage = "錯誤帳戶名稱。家長可以查看學生帳戶名稱。 Wrong account name. Parents can view student account names.";
                break;
              default:
                break;
            }
          })
    },
    onShowError(i) {
      let invalidList = [
        {
          title: "你的帳戶已過期\nYour account has expired",
          tip: "請聯絡家長更新訂閱狀態。\nPlease contact parents to update subscription status.",
        },
        {
          title: "你的帳戶未激活\nYour account is not activated",
          tip: "請聯絡家長激活賬號。\nPlease contact parents to activate the account.",
        },
        {
          title: "你的帳戶訂閱未開始\nYour subscription not start",
          tip: "請等到訂閱開始再登錄。\nPlease wait until your subscription starts before logging in.",
        },
      ];
      this.$confirm(invalidList[i].tip, invalidList[i].title, {
        confirmButtonText: "確定 Confirm",
        showCancelButton: false,
        center: true,
        showClose: false,
        closeOnClickModal: false,
        customClass: "exit-box",
        confirmButtonClass: "exit-confirm",
      })
          .then(() => {})
          .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  //padding:0 60px;
  flex: 1;
}
.security-box {
  width: 43rem;
}
.security-title {
  color: #8e8e8e;
  font-weight: bold;
  line-height: 1.6rem;
}
.security-button {
  margin: 1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  font-size: 1.125rem;
  color: #444444;
}

@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .security-box {
    width: 27rem;
  }
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .contain {
    height: 100%;
  }
  .security-box {
    width: 20rem;
    max-width: 90vw;
  }
}
::v-deep {
  .el-input__inner {
    //border-top-right-radius: 3.125rem;
    //border-bottom-right-radius: 3.125rem;
    border-radius: 0.625rem;
    //background-color: #fffbed;
    border: 0.0625rem solid #a1a1a1;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .el-input-group__prepend {
    border-top-left-radius: 3.125rem;
    border-bottom-left-radius: 3.125rem;
    background-color: #fffbed;
    border: 0.0625rem solid #fffbed;
    padding: 0 1.25rem;
    padding-right: 0;
  }
  .el-form-item__error {
    font-size: 14px;
    line-height: 1.6;
    padding-top: 0;
    position: relative;
  }
  .el-input__icon {
    width: 1.75rem;
    line-height: 2.75rem;
  }
  .el-icon-view {
    vertical-align: top;
  }
  .el-icon-circle-close {
    font-size: 1.75rem;
  }
  .el-icon-circle-check {
    color: #008000;
    font-size: 1.75rem;
  }
  .el-button + .el-button {
    margin: 0;
    margin-top: 1.125rem;
  }
  .security-button:nth-child(1) {
    background-color: #fcc03a;
  }
  .security-button:nth-last-child(1) {
    background-color: #ffffff;
  }
}
</style>